import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './styles.module.css';

const TAX_IDENTIFIER_TYPE_ID = 'taxIdentifierType';
const TAX_IDENTIFIER_NUMBER_ID = 'taxIdentifierNumber';

/**
 * @param {object} props
 * @param {JSX.Element} props.children
 * @returns {JSX.Element} The rendered EditTaxIdentifiersTable
 */
export const EditTaxIdentifiersTable = ({ children }) => (
  <table className={style['tax-id-table']}>
    <thead>
      <tr>
        <th>
          <Text className={style.label} htmlFor={TAX_IDENTIFIER_TYPE_ID} textType={TextType.Label} value={messages.taxIdentifierType} />
        </th>
        <th>
          <Text element='span' htmlFor={TAX_IDENTIFIER_NUMBER_ID} textType={TextType.Label} value={messages.taxIdentifierNumber} />
        </th>
        <th />
      </tr>
    </thead>
    <tbody>{children}</tbody>
  </table>
);
